export const MENSAJE_ERROR_ENVIO_LEAD =
    'No pudimos enviar tu solicitud. Probá de nuevo o escribinos por WhatsApp.';

interface ErrorEnvioLeadProps {
    whatsappHref: string;
}

/** Aviso de envío fallido debajo del botón de los formularios de landings. */
export const ErrorEnvioLead = ({ whatsappHref }: ErrorEnvioLeadProps) => (
    <div role="alert" className="text-center mt-3" style={{ color: 'var(--bs-form-invalid-color)' }}>
        <p className="fs-16 mb-1">{MENSAJE_ERROR_ENVIO_LEAD}</p>
        <a
            href={whatsappHref}
            target="_blank"
            rel="noreferrer"
            className="d-inline-flex align-items-center fs-17 text-black"
        >
            <span>Chatéanos</span>
            <svg className="svg-icon ms-2 w-12em">
                <use xlinkHref="#whatsapp"></use>
            </svg>
        </a>
    </div>
);
